import { Icon as ChakraIcon } from "@chakra-ui/react";
import { colors } from "@permisso/permisso-components";
import { FaCheck } from "react-icons/fa";

import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import styled from "styled-components";

interface Props {
  onClick: () => void;
  checked: boolean;
  className?: string;
  dataTestId?: string;
}

export const CheckboxButton = (props: Props) => {
  return (
    <TouchableArea onClick={props.onClick} data-testid={props.dataTestId}>
      <CheckboxContainer $checked={props.checked}>
        {props.checked ? <StyledIcon as={FaCheck} color={colors.grey0} /> : null}
      </CheckboxContainer>
    </TouchableArea>
  );
};

const CheckboxContainer = styled.div<{ $checked: boolean }>`
  display: flex;
  background-color: ${(props) => (props.$checked ? props.theme.primaryColor : colors.grey0)};
  border-width: 0.0625rem;
  border-color: ${(props) => (props.$checked ? props.theme.primaryColor : colors.grey700)};
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 0.125rem;
  margin-right: 0.5rem;
  align-items: center;
  justify-content: center;
`;

const TouchableArea = styled.div`
  &:hover {
    cursor: pointer;
  }
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}px) {
    padding: 0.25rem;
  }
`;

const StyledIcon = styled(ChakraIcon)`
  width: 1rem;
  height: 1rem;
`;
